const baseKey = '/v1/auth'

export const authAPI = {
  baseKey,
  signin: `${baseKey}/signin`,
  signup: `${baseKey}/signup`,
}
